import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, mergeProps as _mergeProps, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "commonPantryDialogOverlay" }
const _hoisted_2 = { class: "commonPantryDialogBox" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "commonPantryDialogHeaderArea" }, null, -1)
const _hoisted_4 = { class: "commonPantryTitleArea" }
const _hoisted_5 = { class: "commonPantryTitleText" }
const _hoisted_6 = { class: "pantry-value-dialog-button-view-area" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "pantry-value-dialog-white" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-value-dialog-text" }, "キャンセル")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "pantry-value-dialog-black" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-value-dialog-text" }, "設定する")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "pantry-value-dialog" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.DETAIL_ITEM_TITLE.STOCK_QUANTITY), 1)
          ]),
          _createVNode("div", _mergeProps({ class: "pantry-value-dialog-select-area" }, _ctx.updateValue), [
            _withDirectives(_createVNode("select", {
              class: "pantry-value-dialog-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectValue = $event))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getValueList(), (valueItem) => {
                return (_openBlock(), _createBlock("option", {
                  key: valueItem,
                  value: valueItem
                }, _toDisplayString(valueItem), 9, ["value"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512), [
              [_vModelSelect, _ctx.selectValue]
            ])
          ], 16),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", {
              class: "pantry-value-dialog-button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickClose(...args)))
            }, [
              _hoisted_7
            ]),
            _createVNode("div", {
              class: "pantry-value-dialog-button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickSetting(...args)))
            }, [
              _hoisted_8
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}